import FreactalStore from './FreactalStore';

export default FreactalStore;



// WEBPACK FOOTER //
// ./src/components/FreactalStore/index.js